(function($){
  $(document).ready(function() {

    $('.admin-quantite').on( 'click', function(e) {
        e.preventDefault();
        var id_livraison = $(this).data('livraison');
        $.ajax({
            url: '/inc/xhr/actions_admin.php?action=admin_quantite&id_livraison='+id_livraison,
            success: function(data) {
                $.popin.alert({title: "Définir les quantités", message: data, button: "annuler"});
                //$.popin.confirm({title: "Définir les quantités", message: data, button: "Enregistrer", callback: function(){sauvegarder_quantites_livraison();}});
            }
        });
    });

    $('.dupliquer-livraison').on( 'click', function(e) {
        e.preventDefault();
        var id_livraison = $(this).data('livraison');
        $.ajax({
            url: '/inc/xhr/actions_admin.php?action=dupliquer_livraison&id_livraison='+id_livraison,
            success: function(data) {
                window.location.href='/index.php?rubrique_id=1&admin=Livraison&modif_id='+data
            }
        });
    });


  });
})(jQuery);

